import { Component, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Translates a widget label and applies formatting to it
 */
@Component({
  selector: 'widget-label',
  templateUrl: './widget-label.component.html',
  styleUrls: ['./widget-label.component.scss']
})
export class WidgetLabelComponent implements OnInit {
  /**
   * The field name (= translation key)
   */
  @Input() fieldName: string;

  /**
   * Apply a special color?
   */
  @Input() color: string;

  /**
   * The widget
   */

  @Input() widget: WidgetBaseComponent;

  /**
   * Align: left, center, right
   */
  @Input() align: string;

  /**
   * Bold?
   */
  @Input() bold: boolean;

  /**
   * Italic?
   */
  @Input() italic: boolean;

  /**
   * Inline?
   */
  @Input() inline: boolean;

  /**
   * Prefix
   */
  @Input() prefix: string;

  /**
   * Suffix
   */
  @Input() suffix: string;

  /**
   * Rotation
   */
  @Input() rotation: string;

  /**
   * white-space behavior
   */
  @Input() whitespace: string;

  /**
   * A list of css classes
   */
  classes: string[] = [];

  /**
   * CSS transform
   */
  transform = 'none';

  /**
  * white-space behavior
  */
  whiteSpaceStyle = 'normal';

  /**
   * Initializes the component
   */
  ngOnInit() {
    if (this.inline) {
      this.classes.push('d-inline-block');
    }

    if (this.align) {
      this.classes.push('align-' + this.align);
    }

    if (this.bold) {
      this.classes.push('bold');
    }

    if (this.italic) {
      this.classes.push('italic');
    }

    if (this.color) {
      this.classes.push('color-' + this.color);
    }
    else {
      this.classes.push('color-dark-gray');
    }

    if (this.rotation) {
      this.transform = `rotate(${this.rotation})`;
    }

    if (this.whitespace) {
      this.whiteSpaceStyle = this.whitespace;
    }
  }
}
